import { action, computed, makeObservable, observable } from 'mobx'

import { Collection } from '@flowwai-frontend/shared/sales-crm/sales-crm-core'

import { NavItem, UnionNavItemModel } from '../../../types'

import BaseNavItemModel from '../BaseNavItemModel/BaseNavItemModel'

class NavItemModel extends BaseNavItemModel {
   private childrenCollection!: Collection<string, UnionNavItemModel>
   constructor(navItem: NavItem) {
      const { children, ...baseNavItem } = navItem
      super(baseNavItem)

      this.init()
      if (children) this.setChildren(children)

      makeObservable<NavItemModel, 'childrenCollection'>(this, {
         childrenCollection: observable,

         children: computed,

         init: action.bound,
         setChildren: action.bound,
         addChild: action.bound,
         deleteChild: action.bound,
         resetChildren: action.bound
      })
   }

   init = () => {
      this.childrenCollection = new Collection<string, UnionNavItemModel>(
         'The navItem you are looking for does not exist'
      )
   }

   get children(): UnionNavItemModel[] {
      return this.childrenCollection.orderedItems
   }

   resetChildren(): void {
      this.childrenCollection.clearData()
   }

   setChildren(children: UnionNavItemModel[]): void {
      children.forEach(child => {
         this.childrenCollection.addItem(child.id, child)
      })
   }

   addChild(child: UnionNavItemModel): void {
      this.childrenCollection.addItem(child.id, child)
      child.setParent(this)
   }

   hasChild(childId: string): boolean {
      return this.childrenCollection.hasItem(childId)
   }

   deleteChild(childId: string): void {
      this.childrenCollection.deleteItem(childId)
   }

   static createNavItemModel(navItem: NavItem): NavItemModel {
      return new NavItemModel(navItem)
   }
}

export default NavItemModel
